import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { IdealWeight_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import IdealWeightTable from './IdealWeightTable';
import SharedHelmet from "../Helmet";
const TITLE = 'Ideal Weight Calculator - Determine Healthy Weight by Height';
const DESCRIPTION = 'Calculate your ideal weight based on your height using the electronic ideal weight calculator - discover the suitable weight for your body using this easy and reliable calculator.';
const KEYWORDS = 'How to Calculate Ideal Weight, BMI Calculation, Calculate Ideal Weight by Height and Age, Ideal Weight Calculator, BMI Calculator, Calculate Ideal Weight by Height, Calculate Ideal Weight by Age, Importance of Ideal Weight for Health';
const OG_URL = 'https://do-calculate.com/calculator/en/idealweight/';
const apiEndpoint = `${SERVER_URL}/${IdealWeight_EndPoint}`;
function IdealWeightCalculator() {
    const [height, setHeight] = useState('');
    const [gender, setGender] = useState('');
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    };
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    const calculateIdealWeight = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ height, gender }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
  <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '32px' }}>
                        <h1 style={{ fontSize: '16px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        Want to know your ideal weight? Use the Ideal Weight Calculator to get the weight considered ideal for your health and fitness based on your height and gender. The calculator provides an accurate calculation of ideal weight for various scenarios based on the specified gender (e.g., ideal weight for a height of 160 or 165).
                                        <br /> Afterward, the calculator calculates the ideal weight for height and ideal weight for each case based on the selected gender (e.g., ideal weight for a height of 160 or 165).
                                        <br />
                                        Calculating ideal weight is an important key to maintaining health and fitness. Use the calculator now and get the result quickly and easily. Try calculating ideal weight for men, calculating ideal weight for women, calculating ideal weight by height, or calculating ideal weight by age and check your ideal weight now!
                                        <br />
                                        <hr />
                                    </div>
                                    <br />
                                </div>
                                <MobileUnderCalAds />
                                <div className="row">
                                    <div className="col-sm-12 col-md-5 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            Ideal Weight
                                        </div>
                                        <hr />
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label htmlFor='height' className="form-label ms-2">Height</label>
                                            </b>
                                            <input
                                                type="number"
                                                id="weightNumber"
                                                value={height}
                                                onChange={handleHeightChange}
                                                className="form-control ml-2"
                                                style={{ width: '75px' }}
                                                placeholder="175"
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">cm</span>
                                            </div>
                                        </div>
                                        <br/>                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label >Gender</label>
                                            </b>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    name="gender"
                                                    value="male"
                                                    id="male"
                                                    checked={gender === "male"}
                                                    onChange={handleGenderChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="male">
                                                    Male
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    type="radio"
                                                    name="gender"
                                                    id="female"
                                                    checked={gender === "female"}
                                                    onChange={handleGenderChange}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label" htmlFor="female">
                                                    Female
                                                </label>
                                            </div>
                                        </div>
                                        <br/>                                        <hr />
                                        <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateIdealWeight} disabled={isLoading}>
                                            {isLoading ? (
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                'Calculate'
                                            )}
                                        </button>
                                    </div>
                                    <div className="col-sm-12 col-md-7">
                                        {result && (
                                            <div>
                                                <div className="alert alert-success">
                                                    <h5>Results:</h5>
                                                </div>
                                                <hr />
                                                <IdealWeightTable result={result}></IdealWeightTable> <br />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <br />
                                        {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly.</div>}
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.healthCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">{TITLE}</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Ideal Weight: Everything You Need to Know About Ideal Weight and How to Calculate It</h2></u>
                                <p>
                                    Ideal weight is a term that piques the interest of many, but what exactly is it? Ideal weight is the weight considered best for your overall health based on your height, age, and gender. Knowing your ideal weight can be an important step towards living a healthy and active life. In this article, we will take a look at how to calculate ideal weight and its importance for health.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Ideal Weight for Men and Women:</h2></u> <br />
                                <p>
                                    Ideal weight varies between men and women. Generally, ideal weight for women is slightly less than for men due to differences in body composition and biology. So, it is essential to consider these differences when determining your ideal weight.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How to Calculate Ideal Weight:</h2></u> <br />
                                <p>
                                    Calories are one of the most important concepts in the world of nutrition and health. Knowing how many calories your body needs can be the key to proper nutrition and maintaining a healthy weight. In this article, we will learn how to calculate the calories your body needs and their importance in maintaining your health.
                                </p>
                                We use four different equations to calculate ideal weight:
                                <br />
                                <div>
                                    <b>G. J. Hamwi Formula (1964)</b><br />
                                    The formula closely approximates an acceptable range. However, its widespread use has not been as intensive as Devine's formula. It has been criticized by many critics who argue that many people who use ideal weight do not accept changes easily.<u> It is calculated as follows:</u> <br />
                                    <br />  <div className="alert alert-info">
                                        <ul>
                                            <li>
                                                For males: Ideal body weight (in kilograms) = 48 kg + 2.7 kg for each centimeter above 152 cm.
                                            </li>
                                            <li>
                                                For females: Ideal body weight (in kilograms) = 45.5 kg + 2.2 kg for each centimeter above 152 cm.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <b>B. J. Devine Formula (1974)</b><br />
                                    In his approach, Devine clarified that a man with a height of 5 feet (152 cm) should weigh 50 kilograms, while a woman with a height of 5 feet (152 cm) should weigh 45.5 kilograms. For each additional foot, the ideal body weight should be adjusted by 2.3 kilograms.<u> It is calculated as follows:</u> <br />
                                    <br />  <div className="alert alert-info">
                                        <ul>
                                            <li>
                                                For males: 50.0 kg + 2.3 kg for each centimeter above 152 cm.
                                            </li>
                                            <li>
                                                For females: 45.5 kg + 2.3 kg for each centimeter above 152 cm.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div>
                                    <b>J. D. Robinson Formula (1983)</b><br />
                                    In his formula, Robinson took Devine's formula and subjected it to experimental data. He found that the basic number for ideal body weight differs and also made adjustments for people taller than 5 feet (152 cm).<u> It is calculated as follows:</u> <br />
                                    <br />  <div className="alert alert-info">
                                        <ul>
                                            <li>
                                                For males: 52 kg + 1.9 kg for each centimeter above 152 cm.
                                            </li>
                                            <li>
                                                For females: 49 kg + 1.7 kg for each centimeter above 152 cm.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <b>D. R. Miller Formula (1983)</b><br />
                                    Miller's formula is used to calculate ideal body weight based on height. Just like the other formulas mentioned above, Miller's formula does not include important factors that contribute to changes in body weight.<u> It is calculated as follows:</u> <br />
                                    <br />  <div className="alert alert-info">
                                        <ul>
                                            <li>
                                                For males: 56.2 kg + 1.41 kg for each centimeter above 152 cm.
                                            </li>
                                            <li>
                                                For females: 53.1 kg + 1.36 kg for each centimeter above 152 cm.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <b>Healthy BMI Range</b><br />
                                    The World Health Organization (WHO) recommends a healthy BMI range between 18.5 and 25 for both males and females. Based on the BMI range, you can determine the healthy weight for any given height.
                                    <br />
                                    Body Mass Index (BMI) is a widely used scale to determine ideal body weight. It is widely used in the medical field as a quick indicator of potential health complications. Generally, as the BMI increases, the risk of health problems such as obesity, diabetes, heart disease, and others also increases. It is used as an indicator by doctors to provide health advice to patients about potential health problems, especially if there is a significant gradual increase in BMI, which is the current official scale for classifying individuals into different obesity levels.
                                </div>
                                <br />
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>The Importance of Ideal Weight for Health:</h2></u> <br />
                                <p> Ideal weight has a significant impact on your health. If you are experiencing an abnormal weight gain, it can increase the risk of various diseases such as heart disease, diabetes, and high blood pressure. On the other hand, if you are under ideal weight, you may be susceptible to health problems such as osteoporosis and malnutrition.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Conclusion:</h2></u> <br />
                                <p> Ideal weight is not just a number on the scale. It depends on many personal factors, including height, age, gender, and health goals. Always consult a doctor or healthcare professional before following any diet or weight loss program to ensure you achieve your goals safely and healthily.
                                    With this information and simple tools like BMI calculation and other formulas, you can work on determining the ideal weight that suits you and contributes to improving your health and overall quality of life.
                                </p>
                                <hr />
                            </div>
                        </div>
                    </div>
                    <br />
                    <u><h2>Frequently Asked Questions</h2></u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Much Does Your Body Weigh?</h3>
                            </div>
                            <div className="info-section-body">
                                Blood in your body weighs about 7% of your total weight.
                                <br />
                                Your bones account for 15%.
                                <br />
                                Your muscles range from 25% to 50% of your body weight.
                                <br />
                                The percentage of fat can be anything from 6% (for athletic men) to 31% for women (average) and 24% for men (also average).
                                <br />
                                When the percentage of fat in your body exceeds 32% for women and 25% for men, you are considered obese. However, considering that muscles make up a significant portion of your potential weight, it's clear that the number you see on the scales may not necessarily be the best number to rely on, especially if you engage in intensive training or resistance exercises regularly.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Does Healthy Weight Mean?</h3>
                            </div>
                            <div className="info-section-body">
                                Healthy weight means having a healthy balance between fat, muscles, and bones, so it may vary slightly for each person. For example, based on your genetic makeup, your 'healthy weight' may differ from the government's recommended health guidelines.
                                <br />
                                If you have a small frame with significant excess weight, you may be considered within the healthy weight range simply because your small frame compensates for the number.
                                <br />
                                Similarly, if you have large bones, it may also affect the number you see on the scales, making it appear that you have more excess weight than you actually do.
                                <br />
                                Additionally, it appears that there are differences in how genetic makeup affects our weight. Research published in the International Journal of Obesity has shown that the relationship between body fat percentage and Body Mass Index (BMI) in some racial groups was different from others, suggesting that methods of checking 'ideal weight' may need to be adjusted based on your genetic makeup.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Much Should I Weigh?</h3>
                            </div>
                            <div className="info-section-body">
                                The ideal weight for a person is not a precise rule. It greatly depends on each individual. So far, there is no measurement, whether it's IBW (Ideal Body Weight) or Body Mass Index (BMI) or other measurements, that can definitively determine how much a person should weigh to be healthy. They are just references, and more importantly, it's about adopting healthy lifestyle choices such as regular exercise, eating a variety of unprocessed foods, getting enough sleep, etc., rather than chasing a specific weight based on a general formula.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Does Age Affect Ideal Weight?</h3>
                            </div>
                            <div className="info-section-body">
                                In theory, age should not be a significant factor in ideal weight after the ages of 14-15 for girls and 16-17 for boys; after that, most people stop growing. It's expected that humans, both males and females, will lose about 1.5 to 2 inches in height by the age of 70. It's important to remember that as people age, lean muscle decreases, and it becomes easier to accumulate excess fat in the body. This is a natural process, although the effects of aging can be mitigated by adopting different habits like monitoring your diet, exercising, managing stress, and ensuring adequate sleep.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Does Gender Affect Ideal Weight?</h3>
                            </div>
                            <div className="info-section-body">
                                Generally, females weigh less than males even though they usually have a higher percentage of body fat naturally. Males typically have a larger muscle mass, and muscles weigh more than fat. Additionally, females tend to have lower bone density. Finally, males tend to be taller than females.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Does Height Affect Ideal Weight?</h3>
                            </div>
                            <div className="info-section-body">
                                The taller a person is, the more muscle and fat mass they have in their body, resulting in a higher weight. A male at the same height as a female should weigh approximately 10-20% heavier.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Does Body Frame Size Affect Ideal Weight?</h3>
                            </div>
                            <div className="info-section-body">
                                Body frame size is another factor that can significantly affect the measurement of ideal weight. Body frame size is usually categorized as small, medium, or large. It is measured based on wrist circumference relative to height. Here's how body frame size is classified:
                                For women:
                                - Height less than 5'2":
                                - Small frame = wrist circumference less than 5.5 inches
                                - Medium frame = wrist circumference 5.5 inches to 5.75 inches
                                - Large frame = wrist circumference more than 5.75 inches
                                - Height between 5'2" and 5'5":
                                - Small frame = wrist circumference less than 6 inches
                                - Medium frame = wrist circumference 6 inches to 6.25 inches
                                - Large frame = wrist circumference more than 6.25 inches
                                - Height over 5'5":
                                - Small frame = wrist circumference less than 6.25 inches
                                - Medium frame = wrist circumference 6.25 inches to 6.5 inches
                                - Large frame = wrist circumference more than 6.5 inches
                                For men:
                                - Height over 5'5":
                                - Small frame = wrist circumference 5.5 inches to 6.5 inches
                                - Medium frame = wrist circumference 6.5 inches to 7.5 inches
                                - Large frame = wrist circumference more than 7.5 inches
                                A person with a large bone structure will naturally weigh heavier than a person with a small bone structure, even at the same height, making body frame size a factor that can affect measurements like ideal weight and Body Mass Index (BMI).
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Are the Health Effects of Unhealthy Weight for Women?</h3>
                            </div>
                            <div className="info-section-body">
                                Underweight, overweight, and obesity all increase your risk for several serious health problems:
                                <br />
                                - Menstrual problems. Excessive weight loss can lead to irregular or absent periods.
                                <br />
                                - Osteoporosis. Being underweight increases your risk of developing osteoporosis, a condition that makes bones weak and easy to break.
                                <br />
                                - Depression. Studies suggest that depression is more common in underweight women compared to women with a healthy weight.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Are Some Tips for Successful Weight Loss?</h3>
                            </div>
                            <div className="info-section-body">
                                How quickly you gain or lose weight can be entirely different from person to person based on their genetics, biological methods, and history. Try some or all of the following tips to help you:
                                <br />
                                - Set realistic goals. Talk to your doctor or nurse about your goals and how to achieve them.
                                <br />
                                - Plan your meals in advance and cook more at home.
                                <br />
                                - Focus on eating healthy foods. Getting most of your calories from plant-based protein, whole grains, fruits, and vegetables may help you lose weight safely.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Does Weight Affect Health?</h3>
                            </div>
                            <div className="info-section-body">
                                If you are overweight or obese, your risk of developing health problems related to this weight may increase. These conditions include:
                                <br />
                                - Heart diseases caused by clogged arteries.
                                <br />
                                - High blood pressure.
                                <br />
                                - Stroke.
                                <br />
                                - Type 2 diabetes.
                                <br />
                                - Osteoporosis.
                                <br />
                                - Gout.
                                <br />
                                - Some types of cancer.
                                <br />
                                - Asthma.
                                <br />
                                - Sleep-related breathing disorders (sleep apnea).
                                <br />
                                - Fertility problems for both men and women.
                                <br />
                                You may also be prone to difficulty in breathing and lower back pain. Obesity can also make surgical procedures and anesthesia more risky.
                                <br />
                                As for being underweight, it may be due to not getting enough of the right nutrients in the diet. This underweight condition can also increase the risk of developing some health problems such as:
                                <br />
                                - Muscle weakness.
                                <br />
                                - Increased risk of diseases and infections.
                                <br />
                                - Increased risk of certain heart conditions.
                                <br />
                                - Fertility problems.
                                <br />
                                - Slower wound healing.
                                <br />
                                Committing to a healthy weight will reduce the chances of developing these health problems.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default IdealWeightCalculator;
